module.exports = __webpack_public_path__ + "static/image0002-c0fde6190e7c38d4384186cbb5b4829a.jpg";